<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
            </template>
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            This letter concerns the following accounts:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>

        <p class="letter-content">
            I disputed the referenced account(s) above on {{ originalDisputeDate != null ? moment(originalDisputeDate).format('LL') : '(Insert Date)' }}. The credit report of {{ dateAccountRemoved != null ? moment(dateAccountRemoved).format('LL'):'(Insert Date)' }} shows this item was deleted from my credit file. Today {{ date }} I notice the items below have been re-inserted into my credit file. You are required to notify me within five
            (5) days of reinserting a previously deleted item. I did not receive any such notification. Delete the items immediately or I will be forced to take legal action!.
        </p>
        <p class="letter-content">
            Under the requirements of the FCRA, as provided below, I am hereby requesting your complete compliance with all of the provisions:
        </p>
        <P class="letter-content">
            <b>FCRA § 611, Procedure in case of disputed accuracy [15 U.S.C. § 1681i]</b>
        </P>
        <P class="letter-content">
            Requirements relating to reinsertion of previously deleted material.
        </P>
        <ul>
            <li class="letter-content">
                Certification of accuracy of information. If any information is deleted
                from a consumer’s file pursuant to subparagraph (A), the information may
                not reinserted in the file by the consumer reporting agency unless the
                person who furnishes the information certifies the information is complete
                and accurate.
                <br>
            </li>
            <li class="letter-content">
                If any information that has been deleted from a consumer’s file pursuant to
                subparagraph (A) is reinserted in the file, the consumer reporting agency
                shall notify the consumer of the reinsertion in writing not later than 5
                business days after the reinsertion or, if authorized by the consumer for
                that purpose, by any other means available to the agency. Additional information.
                As part of, or in addition to, the notice under clause (ii), a consumer reporting
                agency shall provide to a consumer in writing no later than 5 business days after
                the reinsertion date.
                <br>
            </li>
            <li class="letter-content">
                <ul>
                    <li class="letter-content">
                        (I) a statement that the disputed information has been reinserted;
                        <br>
                    </li>
                    <li class="letter-content">
                        (II) the business name and address of any furnisher of information
                        contacted and the telephone number of such furnisher, if reasonably
                        available, or of any furnisher of information that contacted the
                        consumer reporting agency, in connection with the reinsertion of
                        such information; and
                        <br>
                    </li>
                    <li class="letter-content">
                        (III) a notice that the consumer has the right to add a statement
                        to the consumer’s file disputing the accuracy or completeness of
                        the disputed information.
                    </li>
                </ul>
            </li>


        </ul>
        <P class="letter-content">
            I have received no such notification. This is a serious violation of the FCRA, and
            I reserve the right to pursue further action. <b>Your company may avoid such action by
            immediately deleting this listing from my credit report.</b>
        </P>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate: {
                type: String
            },
            dateAccountRemoved: {
                type: String
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>

